import React, { useRef, useEffect, ReactNode, useState } from 'react';
import NextImage from 'next/image';
import CallMadeIcon from '@mui/icons-material/CallMade';
import styles from './style.module.scss';
import { buildClassName } from 'utils/build-class-name';
import { useKeenSlider } from 'keen-slider/react';
import PlayButtonIcon from 'components/icon/play-button';
import Button, { PRIMARY_THEME, SECONDARY_THEME } from 'components/control/button';

const NUM_SLIDES = 6;

export default function GetInTouch() {
  const animation = { duration: 16000, easing: (t: number) => t };
  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const [sliderRef] = useKeenSlider({
    loop: true,
    renderMode: 'performance',
    drag: false,
    slides: {
      perView: 'auto',
      spacing: 5,
    },
    created(s) {
      s.moveToIdx(NUM_SLIDES - 1, true, animation);
    },
    updated(s) {
      s.moveToIdx(s.track.details.abs + NUM_SLIDES - 1, true, animation);
    },
    animationEnded(s) {
      s.moveToIdx(s.track.details.abs + NUM_SLIDES - 1, true, animation);
    },
  });

  const handleClickPlayButton = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const PlayButton = () => {
    const [isHovered, setIsHovered] = useState(false);
  
    const handleMouseEnter = () => setIsHovered(true);
    const handleMouseLeave = () => setIsHovered(false);
  
    return (
      <button id='playButton' className={buildClassName(styles['play-button'], isPlaying && styles.invisible)}
        onClick={handleClickPlayButton}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <PlayButtonIcon foregroundFill={isHovered || isPlaying ? '#0C0F24': 'white'} backgroundFill={isHovered || isPlaying ? 'white' :'#0C0F24'}/>
      </button>
    );
  };

  return (
    <div className={styles.component}>
      <h2>Get in Touch</h2>
      <div className={styles['cta-and-video-container']}>
        <div className={styles['cta-container']}>
          <div className={styles['cta-text']}>
            <p>Need more information? Get in touch with an expert at eXp Commercial today.</p>
          </div>
          <div className={styles['cta-buttons']}>
            <Button theme={PRIMARY_THEME} label='Get in Touch' />
            <Button theme={SECONDARY_THEME} label='Join Us' />
          </div>
        </div>
        <div className={styles['video-container']}>
          <PlayButton />
          <video
            ref={videoRef}
            width="100%"
            playsInline
            muted
            controls={false}
            loop={true}
          >
            <source src={'/assets/video-section1.mp4'} type="video/mp4" />
            Your browser doesnt support HTML video.
          </video>
        </div>  
      </div>
      <div ref={sliderRef} className={buildClassName(styles['slider'], 'keen-slider')}>
        {Array.from({ length: NUM_SLIDES }).map(_ => (
          <div className={buildClassName(styles['slide'], 'keen-slider__slide')}>
            <div>Get in Touch</div>
            <CallMadeIcon />
          </div>
        ))}
      </div>
    </div>
  );
}
